
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator'
import scroll from '@/mixins/scroll'
import {
  getStoreOrder,
  cusStockInStoreOrder,
  storeGoodsAgain,
  cancelStoreOrder,
  getStoreOrderCanReturn
} from '@/api/industryMall'
import { ShopOrderInfoDto, OrderDelDTO } from './order'
import { Getter } from 'vuex-class'
import PayBtn from '@/views/iousServices/template/payBtn.vue'
import store from '@/store'
import OrderReturnList from '@/views/industryMall/order/returnOrder/ReturnOrderList.vue'
import goodsListPopup from './template/goodsListPopup.vue'
import SupplementaryPayBtn from '@/views/iousServices/template/supplementaryPayBtn.vue'

interface OrderParamsDTO {
  companyId: string
  partnerCompanyId: string
  storeId?: string
  orderId?: string
  receiveMobile?: string
  goodsName?: string
  receiveMan?: string
  orderStatus?: number | string
  payStatus?: number | string,
  pageSize: number
  pageIndex: number
}
@Component({
  name: 'OrderMallList',
  components: { PayBtn,OrderReturnList, goodsListPopup, SupplementaryPayBtn }
})
export default class OrderMallList extends Mixins(scroll) {
  @Getter partnerCompanyId!: string
  @Getter companyId!: string
  @Getter whiteStrips!: number
  @Prop({default:''}) searchKey?:string
  tabKeys = ''
  showDetail = false // 展示明细
  error = false

  tabActions = [
    { text: '全部', value: '-1', id: 0 },
    { text: '待支付', value: '99', id: 99 },  // 和接口确认 value取值
    { text: '待发货', value: '0', id: 1 },
    { text: '待收货', value: '10', id: 2 },
    { text: '已完成', value: '30', id: 3 },
    { text: '退货/售后', value: '-100', id: 4}
  ]

  refreshing = false
  loading = false
  finished = false
  params: OrderParamsDTO = {
    companyId: '',
    partnerCompanyId: '',
    // 订单编号
    orderId: '',
    // 手机号
    receiveMobile: '',
    // 商品名称
    goodsName: '',
    // 收货人姓名
    receiveMan: '',
    pageIndex: 1,
    pageSize: 20
  }
  orderList: ShopOrderInfoDto[] = []
  controller: any
  clickedItemIndex = 0
  isActivated = false
  dataDetail:any = {} // 明细数据


  created() {
    this.params.partnerCompanyId = this.partnerCompanyId
    this.params.companyId = this.companyId
    const { orderType, payType } = this.$route.query
    // console.log('orderType', orderType)
    if (orderType || payType) {
      this.tabKeys = orderType as string || payType  as string
    }
    // this.getOrderList()
  }

  mounted() {
    this.$addScrollListener('.van-tabs__content')
  }

  openShowDetail (data:any) {
    this.showDetail = true
    this.dataDetail = data
  }

  closeShowDetail () {
    this.showDetail = false
  }

  activated() {
    if (this.isActivated) {
      this.handleActivated()
      this.$setScrollY()
    } else {
      this.isActivated = true
    }
  }

  deactivated() {
    this.$removeScrollListener()
  }

  /**
   * @description 从订单详情返回刷新当前页数据，当前页之后的数据清除
   **/
  handleActivated() {
    const pageIndex = Math.trunc(this.clickedItemIndex / this.params.pageSize) + 1
    const params = { ...this.params, pageIndex }
    getStoreOrder(params).then((res) => {
      if (pageIndex > 1) {
        const preData = this.orderList.slice(0, (pageIndex - 1) * this.params.pageSize)
        const data = preData.concat(res.data.records)
        // data.forEach((item: ShopOrderInfoDto) => {
        //   const oldItem = this.orderList.find(i => i.orderId === item.orderId)
        //   this.handleToggleData(item, oldItem)
        // })
        this.orderList = JSON.parse(JSON.stringify(data))
      } else {
        // res.data.records && res.data.records.forEach((item: ShopOrderInfoDto) => {
        //   const oldItem = this.orderList.find(i => i.orderId === item.orderId)
        //   this.handleToggleData(item, oldItem)
        // })
        this.orderList = res.data.records
      }
      this.params.pageIndex = pageIndex
      if (Number(pageIndex) >= res.data.totalPages) {
        this.finished = true
      } else {
        this.finished = false
      }
    })
  }

    /* 申请退货 */
  applyReturnGoods(list) {
    // this.$router.push({
    //   path:'/mallChoosePackage',
    //   query: {
    //     orderId:this.orderId
    //   }
    // })
    // const arr = []
    // this.orderInfo.orderDtlList.forEach((item) => {
    // this.orderInfo.del.forEach((item) => {
    //   if (item.saleAmount) {
    //     arr.push({
    //       // orderDtlId: item.orderDtlId,
    //       returnAmount: item.saleAmount
    //     })
    //   }
    // })
    // if (arr && arr.length > 0) {
    const obj = {
      orderId: list.orderId,
      storeId: list.storeId
    }
    //   // verifyReturnOrderDtl(obj)
    getStoreOrderCanReturn(obj)
      .then((res) => {
        if (res.code === '000000') {
          const data = res.data
          if (data && data.isCanReturn) {
            // 去除中间页
            this.$router.push({
              path: '/mallChoosePackage',
              query: {
                orderId: list.orderId,
                storeId: list.storeId,
                buyCompanyId: list.buyCompanyId,
                form: 'list'
              }
            })
          } else {
            this.$toast.fail({
              message: '该订货单不可退货，请重新选择',
              duration: 1500,
              onClose: () => {
                this.onRefresh()
              }
            })
          }
        }
      })
      .catch(() => {})
    // } else {
    //   this.$toast('此订单没有可退的商品')
    // }
  }

  // 是否显示立即支付按钮
  isShowPay(list) {
    console.log('list')
    if(Number(list.orderStatus) === -1) {
      return false
    }
    // if(Number(list.payWay) === 0 && Number(list.payStatus) === 3) {
    //   return true
    // }
    // if([2,3].includes(Number(list.payWay))) {
    //   return [1,3,-1].includes(Number(list.payStatus))
    // }
    // const showStatus = [1,-1]
    // return showStatus.includes(Number(list.payStatus))
    if(Number(list.payStatus) === 1 || Number(list.payStatus) === -1) {
      return true
    }
    if( Number(list.payStatus) === 3 && Number(list.alternateMoney)===0  && ((list.payWay === '2') || list.payWay ==='3')) {
      return true
    }
    // if (Number(list.orderStatus) === -1) {
    //   return false
    // }
  }

  // 是否显示 候补金额按钮
  isShowPay1(list) {
    if (Number(list.orderStatus) === -1) {
      return false
    }
    if(Number(list.payStatus) === 3 && Number(list.alternateMoney)>0) {
      return true
    }
    if((Number(list.payStatus) === 2 || Number(list.payStatus) === 4) && Number(list.alternateMoney)>0) {
      return true
    }
    // const showStatus = [2,-1]
    // const payStatus = [2,3]
    // return showStatus.includes(Number(list.alternateStatus)) && payStatus.includes(Number(list.payStatus))
  }


  /**
   * 是否显示取消订单按钮
   */
  isShowCancel(list) {
    if(Number(list.orderStatus) === -1) {
      return false
    }
    if([10,30].includes(Number(list.orderStatus))) {
      return false
    }
    if([0,1].includes(Number(list.payWay)) && Number(list.payStatus) === 1) {
      return true
    }
    if([2,3].includes(Number(list.payWay))) {
      return [1,-1].includes(Number(list.payStatus))
    }
    return false
  }

  @Watch('tabKeys')
  handleTabKeys() {
    if (this.tabKeys === '-1') {
      this.params.orderStatus = ''
      this.params.payStatus = ''
    } else {
      if (this.tabKeys === '99') {
        this.params.payStatus = 0
        this.params.orderStatus = ''
      } else{
        this.params.orderStatus = this.tabKeys
        this.params.payStatus = ''
      }
    }
    this.params.pageIndex = 1
    console.log('tabKeys',this.tabKeys, this.params.pageIndex)
    this.finished = false
    this.loading = true
    this.orderList = []
    if (this.controller) {
      console.log('123', this.controller)
      this.controller.abort()
    }
    this.getOrderList()
  }

  /**
   * @description 关联退单
   *
   */
  goReturnList(list) {
    // 确保订单列表页面刷新
    this.$eventBus.$emit('refreshStatus', {status:'退款申请',orderId:list.orderId})
    // this.$router.replace({
    //   path: '/orderMall',
    //   query: {
    //     // orderType:'',
    //     orderName: '退货售后',
    //     orderId:list.orderId
    //   }
    // })
  }

  // 搜索
  onSearch(val) {
    // console.log('val', val)
    this.params.goodsName = val
    this.params.orderId = val
    this.params.receiveMan = val
    this.params.receiveMobile = val
    this.params.pageIndex = 1
    this.orderList = []
    this.getOrderList()
  }
  onCancel() {
    console.log('213')
    this.params.goodsName = ''
    this.params.orderId = ''
    this.params.receiveMan = ''
    this.params.receiveMobile = ''
    this.params.pageIndex = 1
    this.orderList = []
    this.getOrderList()
  }

  handleBack() {
    this.$router.replace('/shopOrder')
  }

  getOrderList() {
    this.error = false
    if (this.params.orderStatus === 'undefined') return
    // getOrderInfoListApp(this.params)
    this.controller = new AbortController()
    const signal = this.controller.signal
    getStoreOrder({ ...this.params }, { signal })
      .then((res) => {
        this.error = false
        // console.log('res', res)
        if (this.refreshing) {
          this.orderList = []
        }
        // this.orderList = res.data.records || []
        const orderList = this.orderList.concat(res.data.records) || []
        // orderList.forEach((item: ShopOrderInfoDto) => { this.handleToggleData(item, null) })
        this.orderList = JSON.parse(JSON.stringify(orderList))
        if (Number(this.params.pageIndex) >= res.data.totalPages) {
          console.log('123434---------')
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(err => {
        this.error = true
        this.params.pageIndex = 0
      })
      .finally(() => {
        this.refreshing = false
        this.loading = false
      })
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    if (this.controller) {
      this.controller.abort()
    }
    this.getOrderList()
  }

  /**
   * 上拉加载更多
   */
  onLoad() {
    console.log('1234')
    // this.loading = true
    this.params.pageIndex++
    this.getOrderList()
  }

  toDetail(id: string, index: number) {
    this.clickedItemIndex = index
    this.$router.push({
      path: '/OrderMallDetail',
      query: {
        orderId: id
      }
    })
  }

  /**
   * 再次购买
   * @param data 订单数据
   */
  buyAgain(data: ShopOrderInfoDto) {
    const obj = {
      orderId: data.orderId,
      storeId: data.storeId
    }
    storeGoodsAgain(obj)
      .then((res) => {
        this.$toast.success(res.msg)
        store.dispatch('getShopCarNum', this.partnerCompanyId)
      })
      .catch(() => {})
  }

  /**
   * 确认收货
   * @param data 订单数据
   */
  confirmOrder(data: ShopOrderInfoDto) {
    const obj = {
      orderId: data.orderId,
      storeId: data.storeId,
      remake: data.orderRemark
    }
    cusStockInStoreOrder(obj)
      .then((res) => {
        let msg = ''
        if (res.code === '000000') {
          msg = '确认收货成功'
        } else if (res.code === '000002') {
          msg = '订货单状态已变更'
        }
        this.$dialog
          .alert({
            message: msg
          })
          .then(() => {
            // this.getOrderList()
            this.onRefresh()
          })
      })
      .catch(() => {})
  }

  /**
   * 取消订单
   * @param orderId
   *
   */
  cancelOrder(data) {
    this.$dialog
      .confirm({
        title: '是否取消订单',
        showCancelButton: true,
        overlay: true
      })
      .then(() => {
        // on confirm
        let params = {
          orderId: data.orderId
        }
        cancelStoreOrder(params).then((res) => {
          let msg = ''
          if (res.code === '000000') {
            msg = '取消订单成功'
          } else if (res.code === '000002') {
            msg = '订货单状态已变更，不可取消订单'
          }
          this.$dialog
            .alert({
              message: msg
            })
            .then(() => {
              // this.getOrderList()
              this.onRefresh()
            })
        })
      })
      .catch(() => {
        // on cancel
      })
  }
  showGoodsList (list: any) {
    (this.$refs.goodsList as any).showPop(list)
  }
}
